<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="7em" class="baseInfoForm">
            <el-form-item label="学历" prop="educationalBackground">
                <el-select v-model="form.educationalBackground" placeholder="请选择学历" filterable>
                    <el-option v-for="item in educationalBackgroundOptions" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="学校" prop="school">
                <el-input
                        v-model="form.school"
                        placeholder="请输入学校名称"
                        maxlength="30">
                </el-input>
            </el-form-item>

            <el-form-item label="就读时间" required>
                <el-col :span="11">
                    <el-form-item prop="studyTime">
                        <el-date-picker
                                v-model="form.studyTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="入学日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2" class="line">至</el-col>
                <el-col :span="11">
                    <el-form-item prop="graduationTime">
                        <el-date-picker
                                v-model="form.graduationTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="毕业日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form-item>

            <el-form-item label="专业" prop="speciality">
                <el-input
                        v-model="form.speciality"
                        placeholder="请输入专业名称"
                        maxlength="30">
                </el-input>
            </el-form-item>

            <!--<el-form-item>-->
                <!--<el-button type="primary" round @click="saveEducationExperience()">保存</el-button>-->
                <!--<el-button type="primary" round >取消</el-button>-->
            <!--</el-form-item>-->

            <el-form-item>
                <el-button type="primary" @click="updateEducationExperience()" v-if="editStatus.status==true">更新保存</el-button>
                <el-button type="primary" @click="saveEducationExperience()" v-else>保存</el-button>
                <el-popconfirm title="确认取消编辑？"
                   @confirm="cancel()"
                   placement="top-start"
                   icon="el-icon-info"
                   icon-color="red"
                   class="ml10">
                    <el-button slot="reference">取消</el-button>
                </el-popconfirm>
            </el-form-item>

        </el-form>
    </div>
</template>
<script>
    import {saveEducationExperience,updateEducationExperience} from '@/api/resume';
    import {getTreeListByDictType} from '@/api/dict';

    export default {
        name: 'educationExperienceForm',
        props: ['form','resumeId','editStatus'],
        data () {
            return {
                educationalBackgroundOptions: [],   // 学历
                rules: {
                    educationalBackground: [
                        {required: true, message: '请选择学历'},
                    ],
                    school: [
                        {required: true, message: '请输入学校'},
                        {pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{0,30}$/, message: '支持输入中英文和数字'}
                    ],
                    studyTime: [
                        {required: true, message: '请选择就读时间'},
                    ],
                    graduationTime: [
                        {required: true, message: '请选择就读时间'},
                    ],
                    speciality: [
                        {pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{0,30}$/, message: '支持输入中英文和数字'}
                    ],
                },
            }
        },
        created() {
            this.loadDictData();
        },
        methods: {
            /** 获取字典数据 */
            loadDictData() {
                getTreeListByDictType("education").then(response => {
                    this.educationalBackgroundOptions = response.data;
                });
            },
            // 保存简历教育经历
            saveEducationExperience(){
                this.$refs["form"].validate(valid=>{
                    if (valid) {
                        this.form.resumeId = this.resumeId;
                        saveEducationExperience(this.form).then(res=>{
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(()=>{
                            this.$message.error("简历教育经历保存失败");
                        })
                    }
                })
            },
            // 保存简历教育经历
            updateEducationExperience(){
                this.$refs["form"].validate(valid=>{
                    if (valid) {
                        this.form.resumeId = this.resumeId;
                        updateEducationExperience(this.form).then(res=>{
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(()=>{
                            this.$message.error("简历教育经历保存失败");
                        })
                    }
                })
            },
            // 简历教育经历表单取消编辑状态
            cancel() {
                this.editStatus.id = 0;
                this.editStatus.status = false;

                this.$emit('editStatus', this.editStatus);
                this.$store.commit('changeResumeEditStatus', false);
                this.$store.commit('changeEducationExperienceEditStatus', false);
            }
        }
    }
</script>